// extracted by mini-css-extract-plugin
export default {"root":"Section__root--p67PM"};